import { useEffect } from 'react';

const GoogleAnalytics = () => {
  useEffect(() => {
    // Only load GA in production or if explicitly enabled
    const shouldLoadGA = process.env.NODE_ENV === 'production' || 
                        process.env.REACT_APP_ENABLE_GA === 'true';
    
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

    if (!shouldLoadGA || !measurementId) {
      return;
    }

    // Initialize dataLayer if it doesn't exist
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    
    // Define gtag function if it doesn't exist
    if (typeof window.gtag === 'undefined') {
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
    }

    // Configure GA
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      page_location: window.location.href,
      page_title: document.title,
      debug_mode: process.env.NODE_ENV === 'development'
    });

    // Load GA script if not already loaded
    if (!document.querySelector(`script[src*="gtag/js?id=${measurementId}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);
    }

  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
